import { createEnvelopeSource } from './create-envelope-source';
import { withCampaignWindows } from './create-campaign-source';
import type { CampaignSourceConfig } from './create-campaign-source';
import { withCampaignRateWindows } from './create-campaign-rate-source';
import { ROAD_TO_REWARDS_CAMPAIGN_ID } from './road-to-rewards-campaign';

type VisitsMetric =
    | 'avgVisitsPerMember'
    | 'repeatVisitRate'
    | 'returningMembers';

/** avgVisitsPerMember and repeatVisitRate both divide by every enrolled
 * member, per the endpoint's own caveat naming the true-visit predicate. */
const config: CampaignSourceConfig<VisitsMetric> = {
    label: 'Campaign visits',
    endpoint: 'analytics/campaign-visits-member',
    metrics: [
        {
            id: 'avgVisitsPerMember',
            label: 'Avg. visits per member',
            type: 'ratio',
        },
        // Same id `engagement`/`login-retention` already declare: one repeat
        // rate metric, reused rather than duplicated (see cards.ts).
        { id: 'repeatVisitRate', label: 'Repeat visit rate', type: 'ratio' },
        {
            id: 'returningMembers',
            label: 'Returning members',
            type: 'scalar',
        },
    ],
    forms: ['trio', 'rate-trio'],
    regionGrain: 'province',
    staticParams: { campaignId: ROAD_TO_REWARDS_CAMPAIGN_ID },
    percentMetrics: ['repeatVisitRate'],
    // A share of members has no weekly or daily average, so its `trio` card
    // reads N/A in both. Not `avgVisitsPerMember`: its numerator accumulates
    // over a fixed denominator, so visits per member per week is real.
    intensiveMetrics: ['repeatVisitRate'],
};

export const campaignVisitsSource = withCampaignRateWindows(
    withCampaignWindows(createEnvelopeSource(config), config),
    config
);
